import React from 'react';
import { Typography } from '@material-ui/core';

export function FieldLabel({ children, ...rest }) {
    return (
        <Typography color="textSecondary" {...rest}>
            {children}
        </Typography>
    );
}

export function FieldText({ children, ...rest }) {
    return (
        <Typography variant="h6" component="h2" gutterBottom {...rest}>
            {children}
        </Typography>
    );
}
